import { Directive, HostBinding, Input } from '@angular/core';
import { coerceBoolean } from 'coerce-property';

export type Dividers = 'static' | 'shifting';

@Directive({
  selector: '[zelisAccordion]',
})
export class AccordionDirective {
  /**
   * Whether to render a stroke for all expansion panels
   */
  @Input() @coerceBoolean stroke!: boolean;
  /**
   * Which dividers, if any, to render between expansion panels
   */
  @Input() dividers?: Dividers;

  @HostBinding('class.stroke') get strokeClass() {
    return this.stroke;
  }
  @HostBinding('class.static-dividers') get staticDividersClass() {
    return this.dividers === 'static';
  }
  @HostBinding('class.shifting-dividers') get shiftingDividersClass() {
    return this.dividers === 'shifting';
  }
}
